
/* eslint import/prefer-default-export: "off" */
const config = {
  apiKey: 'AIzaSyDm2PSAcU1KNJ9leQziYvnzg3OtYYHJ25Q',
  authDomain: 'show-digi.firebaseapp.com',
  databaseURL: 'https://show-digi.firebaseio.com',
  projectId: 'show-digi',
  storageBucket: 'show-digi.appspot.com',
  messagingSenderId: '297151342147',
};
export {
  config as firebaseConfig,
};



// WEBPACK FOOTER //
// ./src/config/index.js